<bb-pagination-ui
  [boundaryLinks]="true"
  [directionLinks]="true"
  [itemsPerPage]="10"
  [maxNavPages]="2"
  [page]="0"
  [totalItems]="totalItems"
  (pageChange)="onPageChange($event)"
></bb-pagination-ui>
